// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"quantity_wrapper__tXp2K","label":"quantity_label__kWtMQ","error":"quantity_error__0H6xe","buttonContainer":"quantity_buttonContainer__vZE0E"};